import { registerLocaleData } from '@angular/common';
import localeRu from '@angular/common/locales/ru';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { configureAppDateLocale } from './app/shared/date/date.utils';
import { environment } from './environments/environment';

registerLocaleData(localeRu);
configureAppDateLocale();

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
